import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import Dialog from '../../Dialog';
import LocationSelector from '../../LocationSelector';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';
import * as Common from './../../Common';

const Vtm_utilization = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [tillDate, setTillDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [generateType, setGenerateType] = useState("V");

    const [locationCode, setLocationCode] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState("O");
    const [utilizationType, setUtilizationType] = useState("I");
    const [scr, setScr] = useState("");
    const [manualReportList, setManualReportList] = useState([]);
    const [selectedIssuer, setSelectedIssuer] = useState(null);
    const [issuerOption, setIssuerOption] = useState("A");
    const [filterCardType, setFilterCardType] = useState("");


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_MIS_VTM_UTILIZATION'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
        setLocationCode(newLocationCode);
        setSelectedItems(newSelectedItems);
        setRadioType(newRadioType);
    }

    const handleGenerate = () => {
        $(".loader").show();

        if (utilizationType == 'I') {
            if (!Common.validateFinYear(Common.dateYMD(tillDate))) {
                $(".loader").hide();
                setMsgText("Date should be within financial year");
                setMsgBox(true);
                return;
            }
        } else if (utilizationType == 'U') {
            if (!Common.validateFinYear(Common.dateYMD(fromDate), Common.dateYMD(toDate))) {
                $(".loader").hide();
                setMsgText("Date should be within financial year");
                setMsgBox(true);
                return;
            } else if (fromDate > toDate) {
                $(".loader").hide();
                setMsgText("From Date should be less than To Date");
                setMsgBox(true);
                return;
            }
        }

        var msg = [], i = 0;
        if ((radioType === 'O' && locationCode === '0') || (radioType == 'S' && selectedItems == []) || (issuerOption === 'O' && selectedIssuer === null)) {
            msg[i++] = ((radioType == 'O' && locationCode == '0') ? "Please select location." : '');
            msg[i++] = ((radioType == 'S' && selectedItems == []) ? "Please select atleast one location." : '');
            msg[i++] = ((issuerOption === 'O' && selectedIssuer === null) ? "Please select Issuer." : '');
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            var grp = null;
            if (issuerOption === 'O') {
                grp = selectedIssuer.id.split('^');
            }
            const obj = {
                utilizationType: utilizationType,
                tillDate: Common.dateDMY(tillDate),
                fromDate: Common.dateDMY(fromDate),
                toDate: Common.dateDMY(toDate),
                type: generateType,
                radioTypeLocation: radioType,
                location: locationCode,
                multipleLocation: selectedItems,
                tillDateDMY: Common.dateDMY(tillDate),
                fromDateDMY: Common.dateDMY(fromDate),
                toDateDMY: Common.dateDMY(toDate),
                groupCode: grp === null ? 0 : grp[1],
                accountCode: grp === null ? 0 : grp[2],
                issuerOption: issuerOption,
                filterCardType: filterCardType

            };
            if (utilizationType === 'I') {
                if (generateType === 'D') {
                    Common.callDownloadApiPost1(Common.apivtmutilization, "post", [sid, "inHandDownloadReport", JSON.stringify(obj)], result => {
                        console.log("this is result ", result);
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                } else {
                    Common.callApi(Common.apivtmutilization, [sid, "inHandViewReport", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });

                }
            } else {
                if (generateType === 'D') {
                    Common.callDownloadApiPost1(Common.apivtmutilization, "post", [sid, "usedDownloadReport", JSON.stringify(obj)], result => {
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                } else {
                    Common.callApi(Common.apivtmutilization, [sid, "usedViewReport", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });

                }
            }
        }
    }
    const handleIssuerChange = value => {
        setSelectedIssuer(value);
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>VTM Utilization</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={utilizationType} onChange={e => setUtilizationType(e.target.value)}
                                required>
                                <option value="I">In Hand</option>
                                <option value="U">Used</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Card<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterCardType} onChange={e => setFilterCardType(e.target.value)}
                                required>
                                <option value="">All</option>
                                <option value="MASTER">Master</option>
                                <option value="VISA">Visa</option>
                                <option value="RUPAY">Rupay</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Issuer Options<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={issuerOption} onChange={e => setIssuerOption(e.target.value)}
                                required>
                                <option value="A">All</option>
                                <option value="O">One</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {issuerOption === 'O' ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Issuer<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions
                                    defaultOptions
                                    value={selectedIssuer}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', locationCode)}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleIssuerChange}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col> : null}
                    <Row>
                        {
                            utilizationType === 'I' ?
                                <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label> Till Date<span className="colorThemeRed">*</span></Form.Label><br />
                                            <DatePicker className="form-control"
                                                selected={tillDate}
                                                onChange={(date) => setTillDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                </> :
                                null
                        }
                        {utilizationType === 'U' ?
                            <>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                        <DatePicker className="form-control"
                                            selected={fromDate}
                                            onChange={(date) => setFromDate(date)}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown

                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col>

                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                        <DatePicker className="form-control"
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col>
                            </> : null}
                    </Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={generateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-6 col-6'>
                        <Form.Label>Location Filter</Form.Label><br />
                        <LocationSelector onDataFromChild={handleDataFromChild} />
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {scr === "V" ? <>
                    <Row>
                        <Col>
                            <Button onClick={() => setScr('')} variant="primary">Back</Button>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                    &nbsp;
                    <Table responsive striped bordered>
                        <thead>
                            <tr>
                                <th>Branch</th>
                                <th>In Type</th>
                                <th>Prefix</th>
                                <th>In Date</th>
                                <th>Out Date</th>
                                <th>Out Serial no.</th>
                                <th>Out Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                manualReportList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.tmb_location + item.entity_name}</td>
                                        <td>{item.tmb_type}</td>
                                        <td>{item.tmb_prefix}</td>
                                        <td>{item.tmb_date}</td>
                                        <td>{item.tmbb_out_date}</td>
                                        <td>{item.tmbb_out_srno}</td>
                                        <td>{item.tmbb_out_type}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </> : null}

            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Vtm_utilization;